import {Alert, Text, ThemeIcon, Tooltip} from '@mantine/core'
import {IconStarFilled} from '@tabler/icons-react'

import {type PartialPickup, partialPickupText} from './partial-pickup-schema'

export function PartialPickupBadge({
    partialPickup,
    compact = false,
}: {
    partialPickup: PartialPickup | null | undefined
    compact?: boolean
}) {
    if (!partialPickup) {
        return null
    }
    if (compact) {
        return (
            <Text
                size="xs"
                fw={600}
                c="orange.8"
                bg="orange.0"
                px={6}
                py={2}
                style={{borderRadius: 4}}
                data-testid="partial-pickup-badge"
            >
                {partialPickupText(partialPickup)}
            </Text>
        )
    }
    return (
        <Alert
            color="orange"
            variant="light"
            icon={<IconStarFilled size={18} />}
            title="Rentals still out"
            data-testid="partial-pickup-badge"
        >
            <Text size="sm">{partialPickupText(partialPickup)}</Text>
            <Text size="xs" c="dimmed">
                Clears when the rest is returned.
            </Text>
        </Alert>
    )
}

export function PartialPickupIcon({
    partialPickup,
}: {
    partialPickup: PartialPickup | null | undefined
}) {
    if (!partialPickup) {
        return null
    }

    const text = partialPickupText(partialPickup)
    return (
        <Tooltip label={text} multiline maw={360} withArrow>
            <ThemeIcon
                color="orange"
                variant="light"
                size="sm"
                radius="xl"
                aria-label={text}
                data-testid="partial-pickup-icon"
            >
                <IconStarFilled size={12} />
            </ThemeIcon>
        </Tooltip>
    )
}
